'use strict';

module.exports = /* @ngInject */ function ($resource, apiConfig) {
	
	var apiUrl = apiConfig.$get().apiUrl;

	return {
		error: function(msg) {
			growl(msg.data.error, 1);
		},
		inventory: $resource(
					apiUrl + '/warehouse/inventory/:inventory_id',
					{
						supplier_company_id:'@supplier_company_id',
						sku:'@sku',
						storage_place_id:'@storage_place_id'
					}, 
					{
						query: {
							isArray: true,
						},
						create: {
							method: 'POST',
							data: '@inventory'
						}, 
						update: {
							method: 'PUT',
							data: '@inventory'
						}, 
						delete: {
							method: 'DELETE'
						}
					}
				)
	};
}
